import { render, staticRenderFns } from "./LetterRecordsTable.vue?vue&type=template&id=1780f5da&scoped=true&"
import script from "./LetterRecordsTable.vue?vue&type=script&lang=js&"
export * from "./LetterRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./LetterRecordsTable.vue?vue&type=style&index=0&id=1780f5da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780f5da",
  null
  
)

export default component.exports